import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HeatIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";

export const IncreaseExpectedElectricHeatingSystemForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEATING_SYSTEM>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HeatIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Speicherheizung, Direktheizung
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricHeatingSystem.value.installed}
                        {...getFieldProps("increaseExpectedElectricHeatingSystem.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricHeatingSystem.value.installed =
                                    checked;
                                values.increaseExpectedElectricHeatingSystem.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricHeatingSystem.value.installed}
                detail={
                    <Fragment>
                        <InputLabel
                            className={classes.labledTextfieldLabel}
                            style={{ marginTop: 0 }}
                        >
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseExpectedElectricHeatingSystem.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={
                                values.increaseExpectedElectricHeatingSystem.value.demand.unit
                            }
                            value={
                                values.increaseExpectedElectricHeatingSystem.value.demand.amount ||
                                ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedElectricHeatingSystem.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseExpectedElectricHeatingSystem.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
